import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import "./SelectMultipleSDGsNum.css";
import { useMediaQuery } from "react-responsive";
import eight from "../assets/img/numbers/eight.png";
import eleven from "../assets/img/numbers/eleven.png";
import fifteen from "../assets/img/numbers/fifteen.png";
import five from "../assets/img/numbers/five.png";
import four from "../assets/img/numbers/four.png";
import fourteen from "../assets/img/numbers/fourteen.png";
import nine from "../assets/img/numbers/nine.png";
import one from "../assets/img/numbers/one.png";
import seven from "../assets/img/numbers/seven.png";
import seventeen from "../assets/img/numbers/seventeen.png";
import six from "../assets/img/numbers/six.png";
import sixteen from "../assets/img/numbers/sixteen.png";
import ten from "../assets/img/numbers/ten.png";
import thirteen from "../assets/img/numbers/thirteen.png";
import three from "../assets/img/numbers/three.png";
import twelve from "../assets/img/numbers/twelve.png";
import two from "../assets/img/numbers/two.png";

import eightChecked from "../assets/img/numbersChecked/eight.png";
import elevenChecked from "../assets/img/numbersChecked/eleven.png";
import fifteenChecked from "../assets/img/numbersChecked/fifteen.png";
import fiveChecked from "../assets/img/numbersChecked/five.png";
import fourChecked from "../assets/img/numbersChecked/four.png";
import fourteenChecked from "../assets/img/numbersChecked/fourteen.png";
import nineChecked from "../assets/img/numbersChecked/nine.png";
import oneChecked from "../assets/img/numbersChecked/one.png";
import sevenChecked from "../assets/img/numbersChecked/seven.png";
import seventeenChecked from "../assets/img/numbersChecked/seventeen.png";
import sixChecked from "../assets/img/numbersChecked/six.png";
import sixteenChecked from "../assets/img/numbersChecked/sixteen.png";
import tenChecked from "../assets/img/numbersChecked/ten.png";
import thirteenChecked from "../assets/img/numbersChecked/thirteen.png";
import threeChecked from "../assets/img/numbersChecked/three.png";
import twelveChecked from "../assets/img/numbersChecked/twelve.png";
import twoChecked from "../assets/img/numbersChecked/two.png";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));

const SelectMultipleSDGsNum = () => {
    const isLong = useMediaQuery({ query: "(min-height: 630px)" });
    const isWide = useMediaQuery({ query: "(min-width: 600px)" });

    const [isCheckedList, setIsCheckedList] = useState(new Array(17).fill(false))
    useEffect(() => {
      
    }, [isCheckedList])
    return <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>

        <div style={{ height: "100vh", margin: "30px 30px 0 30px" }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[0] ? oneChecked : one}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(
                                isCheckedList.map((it, index) => (index === 0 ? !it : it))
                            );
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[1] ? twoChecked : two}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(
                                isCheckedList.map((it, index) => (index === 1 ? !it : it))
                            );
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[2] ? threeChecked : three}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(
                                isCheckedList.map((it, index) => (index === 2 ? !it : it))
                            );
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[3] ? fourChecked : four}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 3 ? !it : it)))
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[4] ? fiveChecked : five}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 4 ? !it : it)))
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[5] ? sixChecked : six}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 5 ? !it : it)))
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[6] ? sevenChecked : seven}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 6 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[7] ? eightChecked : eight}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 7 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[8] ? nineChecked : nine}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 8 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[9] ? tenChecked : ten}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 9 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[10] ? elevenChecked : eleven}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 10 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[11] ? twelveChecked : twelve}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 11 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[12] ? thirteenChecked : thirteen}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 12 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[13] ? fourteenChecked : fourteen}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 13 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[14] ? fifteenChecked : fifteen}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 14 ? !it : it)));
                        }}
                    />
                </Grid>

                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[15] ? sixteenChecked : sixteen}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 15 ? !it : it)));
                        }}
                    />
                </Grid>
                <Grid item xs={4} md={3}>
                    <img
                        src={isCheckedList[16] ? seventeenChecked : seventeen}
                        alt=""
                        style={{ width: "60%" }}
                        onClick={() => {
                            setIsCheckedList(isCheckedList.map((it, index) => (index === 16 ? !it : it)));
                        }}
                    />
                </Grid>
            </Grid>
        </div>

    </div >
}
export default SelectMultipleSDGsNum;